export const isInWebApp = _ => {
  const isIOsWebApp = window.navigator.standalone === true
  const isChromeWebApp = window.matchMedia('(display-mode: standalone)').matches
  return isIOsWebApp || isChromeWebApp
}
